import { z } from 'zod';

/**
 * Zod probes `new Function('')` once, while building its first object schema, to decide whether it
 * may JIT-compile parsers. The CSP we serve has no `unsafe-eval` (see frontend-server/headers.go),
 * so the probe always fails in production — but the browser reports the blocked call as a CSP
 * violation before zod swallows the error. `jitless` skips the probe and costs us nothing: the JIT
 * it gates was never available under that CSP anyway.
 *
 * Import this module for its side effect, as the first import of the entrypoint. The probe runs
 * when the first object schema is built, and importing e.g. client-core builds schemas at module
 * scope, so a later import would be too late. configureZod.test.ts enforces the ordering.
 */
z.config({ jitless: true });
